var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFabricMirrorCampaign = function SvgFabricMirrorCampaign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 37",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.536 14.639l21.848-3.227c.52-.071.941-.452 1.074-.95l1.612-6.82a1.293 1.293 0 00-1.41-1.632L11.811 5.09a5.828 5.828 0 00-4.686 4.213L4.762 18.86c.603-2.204.974-3.533 4.774-4.22z",
    fill: "#2E8071"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.982 16.746c-3.164.573-3.95 1.592-4.473 3.189l-2.09 8.306s.805-2.946 4.7-3.576l14.886-2.168.11-.019a1.384 1.384 0 001.126-1.008l1.785-7.094-16.044 2.37z",
    fill: "#2E8071"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.809 26.417c-3.293.532-4.374 2.713-4.631 3.377a4.568 4.568 0 00-.295 1.62c0 2.35 1.837 3.304 4.119 3.557 1.276.142 3.887-.267 5.925-.548a2.372 2.372 0 001.963-1.726l2.286-7.644-9.367 1.364z",
    fill: "#2E8071"
  })));
};
export default SvgFabricMirrorCampaign;